// @flow

export class GooglePayError extends Error {
}

export class GooglePayCanceledError extends Error {
}
